import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
} from "@mui/material";
import { useState } from "react";
import apiService from "../../../../../service/Api";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../../components/common/ShowToast";
import type { IComment } from "../../../../../types/comment";

interface EditCommentModalProps {
  comment: IComment;
  open: boolean;
  setOpen: (open: boolean) => void;
  refreshComments: (comment: IComment, isDeleting: boolean) => void;
}

export const EditCommentModal: React.FC<EditCommentModalProps> = ({
  comment,
  open,
  setOpen,
  refreshComments,
}) => {
  const [content, setContent] = useState(comment.content);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    try {
      await apiService.patch(`/api/chats/memorial-message/${comment.id}/`, {
        content,
      });
      refreshComments({ ...comment, content }, false);
      showSuccessToast("Comment updated");
      setOpen(false);
    } catch {
      showErrorToast("Failed to update comment");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
      <DialogTitle>Edit Comment</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          multiline
          rows={4}
          value={content}
          onChange={(e) => setContent(e.target.value)}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)} disabled={saving}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={saving || !content.trim()}
        >
          {saving ? <CircularProgress size={16} /> : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};